import React from "react";

import styles from "./School.module.scss";
import { SchoolPropsType } from "./types";
import { SchoolTrainingForm } from "../../Form/SchoolTrainingForm/SchoolTrainingForm";
import schoolImage from "@/assets/img/schoolTraining.svg";
import schoolImageMobile from "@/assets/img/schoolTrainingMobile.svg";
import { SuccessModal } from "../../components/SuccessModal/SuccessModal";
import { useCurrentWidth } from "@/hooks";
import { MediaBreakPoints } from "@/resources/constants";

export const School: React.FC<SchoolPropsType> = ({ title }) => {
  const windowWidth = useCurrentWidth();
  const isMobile = windowWidth <= MediaBreakPoints.DESKTOP;
  const currentImage = isMobile ? schoolImageMobile : schoolImage;

  return (
    <main className={styles.main}>
      <section className="container">
        <div className={styles.wrapper}>
          <div className={styles.content}>
            <h2 className={styles.title}>
              Школа тенниса
            </h2>
            
            <p className={styles.description}>
              Групповые тренировки по теннису и padel для взрослых и детей от 3-х лет
            </p>

            <SchoolTrainingForm />
          </div>
          <div className={styles.imageWrapper}>
            <img src={currentImage} alt="school" className={styles.image} />
          </div>
        </div>
      </section>
      
      <SuccessModal />
    </main>
  );
};
